import React from 'react';
import CollectionPage from '../shared/CollectionPage';

const boardGameConditionOptions = [
  { value: 'New Sealed', label: 'New Sealed' },
  { value: 'Like New', label: 'Like New' },
  { value: 'Very Good (VG)', label: 'Very Good (VG)' },
  { value: 'Good (G)', label: 'Good (G)' },
  { value: 'Fair (F)', label: 'Fair (F)' },
  { value: 'Poor (P)', label: 'Poor (P)' },
  { value: 'Incomplete', label: 'Incomplete' }
];

const boardGameEditFields = [
  { name: 'name', label: 'Game Name', type: 'text', required: true, gridProps: { xs: 12 } },
  { name: 'designers', label: 'Designer(s)', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'publisher', label: 'Publisher', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'year', label: 'Year', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'minPlayers', label: 'Min Players', type: 'number', required: false, gridProps: { xs: 6, sm: 3 } },
  { name: 'maxPlayers', label: 'Max Players', type: 'number', required: false, gridProps: { xs: 6, sm: 3 } },
  { name: 'playingTime', label: 'Playing Time (min)', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'minAge', label: 'Min Age', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'category', label: 'Category', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'genre', label: 'Genre/Mechanic', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  {
    name: 'language', label: 'Language', type: 'select', required: false,
    options: ['English', 'French', 'German', 'Spanish', 'Italian', 'Other'],
    gridProps: { xs: 12, sm: 6 }
  },
  { name: 'condition', label: 'Condition', type: 'select', required: false, options: boardGameConditionOptions, gridProps: { xs: 12, sm: 6 } },
  { name: 'edition', label: 'Edition', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'played', label: 'Played', type: 'checkbox', required: false, gridProps: { xs: 6 } },
  { name: 'favourite', label: 'Favourite', type: 'checkbox', required: false, gridProps: { xs: 6 } },
  { name: 'price', label: 'Price Paid', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'rating', label: 'Rating', type: 'rating', required: false, gridProps: { xs: 12 } },
  { name: 'description', label: 'Description', type: 'textarea', required: false, gridProps: { xs: 12 } },
  { name: 'imageUrl', label: 'Image URL', type: 'text', required: false, gridProps: { xs: 12 } },
  { name: 'notes', label: 'Notes', type: 'textarea', required: false, gridProps: { xs: 12 } }
];

const BoardGameDashboard = () => {
  const boardGameRenderProps = {
    getImageUrl: (item) => item.imageUrl,
    getItemName: (item) => item.name,
    getItemSubtitle: (item) => [
      item.designers || null,
      item.year ? `${item.year}` : null
    ].filter(Boolean).join(' • ') || 'Board Game',
    getItemDetails: (item) => [
      item.category || null,
      item.minPlayers && item.maxPlayers
        ? `${item.minPlayers}–${item.maxPlayers} players`
        : item.minPlayers ? `${item.minPlayers}+ players` : null,
      item.playingTime ? `${item.playingTime} min` : null
    ].filter(Boolean).join(' • ')
  };

  const boardGameFilterOptions = [
    { value: '', label: 'All Categories' },
    { value: 'Strategy', label: 'Strategy' },
    { value: 'Family', label: 'Family' },
    { value: 'Party', label: 'Party' },
    { value: 'Cooperative', label: 'Cooperative' },
    { value: 'Deck Building', label: 'Deck Building' },
    { value: 'Worker Placement', label: 'Worker Placement' },
    { value: 'Roll & Write', label: 'Roll & Write' },
    { value: 'Dungeon Crawler', label: 'Dungeon Crawler' },
    { value: 'Wargame', label: 'Wargame' },
    { value: 'Abstract', label: 'Abstract' },
    { value: 'Trivia', label: 'Trivia' },
    { value: 'Puzzle', label: 'Puzzle' },
    { value: 'Children', label: 'Children' },
    { value: 'Other', label: 'Other' },
  ];

  return (
    <CollectionPage
      collectionType="board-games"
      title="Board Game Collection"
      renderProps={boardGameRenderProps}
      filterOptions={boardGameFilterOptions}
      getFilterValue={(item) => item.category}
      editFields={boardGameEditFields}
    />
  );
};

export default BoardGameDashboard;
